import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getLuckyDrawInfo = createAsyncThunk(
  'LuckyDraw/getLuckyDrawInfo',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/dlottery_buy_page', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const buyLuckyDrawTicket = createAsyncThunk(
  'LuckyDraw/buyLuckyDrawTicket',
  async (p: {num: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/dlottery_buy', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getHistoryLotteryList = createAsyncThunk(
  'LuckyDraw/getHistoryLotteryList',
  async (p: {offset: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/dlottery_period_success', {
      ...store.getState().env.deviceinfo,
      ...p,
      limit: 20,
    })
    return {data: resp.data, offset: p.offset}
  }
)

export const getMyTicketList = createAsyncThunk(
  'LuckyDraw/getMyTicketList',
  async (p: {offset: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/dlottery_person_records', {
      ...store.getState().env.deviceinfo,
      limit: 10,
      ...p,
    })
    return {offset: p.offset, data: resp.data}
  }
)

export const getScoreReward = createAsyncThunk(
  'LuckyDraw/getScoreReward',
  async (p: {head_id: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/dlottery_receive_head', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const showAlertInfo = createAsyncThunk(
  'LuckyDraw/showAlertInfo',
  async (p, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/dlottery_alert', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
const initialState: {
  buy_records: string[]
  success_records: string[]
  buy_status: 1 | 2 // 1购买阶段， 2开奖阶段，不能买
  integral: number // 当前积分

  integral_items: {
    // 积分奖励
    id: number
    desc: string
    expire: number // 有效时长（天）
    score: number
    status: 1 | 2 | 3
    url: string
  }[]
  num: number // 单次可购买奖券数
  price: number // 奖券单价
  remain_t: number // 剩余时间
  target_num: string // 中一等奖的号码
  total: number // 总奖池
  myList: {
    more: boolean
    offset: number
    list: {day: string; num: string; status: number}[]
  }
  round: string // 当前的场次
  records: string[]
} = {
  buy_records: [],
  success_records: [],
  buy_status: 1,
  integral: 0,
  integral_items: [],
  num: 0, // 单次可购买奖券数
  price: 0, // 奖券单价
  remain_t: 0, // 剩余时间
  target_num: '',
  total: 0, // 总奖池
  myList: {
    more: false,
    offset: 0,
    list: [],
  },
  round: '',
  records: [],
}

export const LuckyDrawSlice = createSlice({
  name: 'HiyaLuckyDraw',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLuckyDrawInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getMyTicketList.fulfilled, (state, action) => {
      const {
        data: {data = {}},
        offset,
      } = action.payload
      if (offset) {
        Object.assign(state, {
          myList: {...data, list: [...state.myList.list, ...data.list]},
        })
        return
      }
      Object.assign(state, {myList: data})
    })
  },
})
export default LuckyDrawSlice.reducer
